import { DashboardTileTone } from '../DashboardBirdview.constants'
import { BirdviewChartTone } from '../DashboardBirdview.constants.charts'

export function getBirdviewSparklineColor(tone) {
  switch (tone) {
    case DashboardTileTone.Success:
      return BirdviewChartTone.Success
    case DashboardTileTone.Error:
      return BirdviewChartTone.Error
    case DashboardTileTone.Warning:
      return BirdviewChartTone.Warning
    case DashboardTileTone.Purple:
      return BirdviewChartTone.Purple
    default:
      return BirdviewChartTone.Info
  }
}
